<template>
    <div v-if="users" class="filters-wrapper">
        <div class="filters-header">Filters</div>
        <div class="filters-container">
            <div class="filter">
                <label class="form-field" for="user-select">All Users</label>
                <v-select
                    id="user-select"
                    v-model="usersSelected"
                    :items="users"
                    :attach="true"
                    chips
                    item-text="username"
                    item-value="id"
                    class="form-field"
                    hide-details
                    clearable
                    :disabled="users.length === 1"
                    multiple
                    @click:clear="clearUser"
                />
            </div>
            <div class="filter">
                <label class="form-field" for="scheduledAt">Scheduled At</label>
                <date-picker
                    id="scheduledAt"
                    v-model="scheduledAt"
                    class="form-field"
                    type="datetime"
                    range
                    @clear="clearScheduledAt"
                />
            </div>
            <div class="filter">
                <label class="form-field" for="completedAt">Completed At</label>
                <date-picker
                    id="completedAt"
                    v-model="completedAt"
                    class="form-field"
                    type="datetime"
                    range
                    @clear="clearCompletedAt"
                />
            </div>
            <button-search :callback="filterBuilder" :disabled="isSearchInProgress" />
        </div>
    </div>
</template>

<script>
    import userService from '@/services/user-service'
    import DatePicker from 'vue2-datepicker'
    import dateTimeUtils from '@/utils/date-time-utils'
    import 'vue2-datepicker/index.css'
    import ButtonSearch from '@/components/ButtonSearch.vue'

    export default {
        components: { ButtonSearch, DatePicker },
        props: {
            isSearchInProgress: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                usersSelected: [],
                users: [],
                scheduledAt: null,
                completedAt: null
            }
        },
        computed: {
            isCurrentUserAdmin() {
                return this.$store.getters.isCurrentUserAdmin
            }
        },
        watch: {
            isCurrentUserAdmin(newVal) {
                if (newVal) {
                    userService.getUsers().then(resp => {
                        this.users = resp.data.content
                    })
                } else {
                    this.users = [this.$store.getters.getCurrentUser]
                    this.usersSelected = [this.$store.getters.getCurrentUser.id]
                }
            }
        },
        created() {
            if (this.isCurrentUserAdmin) {
                userService.getUsers().then(resp => {
                    this.users = resp.data.content
                })
            } else {
                this.users = [this.$store.getters.getCurrentUser]
                this.usersSelected = [this.$store.getters.getCurrentUser.id]
            }
        },
        methods: {
            filterBuilder() {
                const filters = {
                    user: this.usersSelected.length > 0 ? this.usersSelected : undefined,
                    scheduledAtGte: this.scheduledAt ? dateTimeUtils.getFormattedDateForSubmit(this.scheduledAt[0]) : undefined,
                    scheduledAtLte: this.scheduledAt ? dateTimeUtils.getFormattedDateForSubmit(this.scheduledAt[1]) : undefined,
                    completedAtGte: this.completedAt ? dateTimeUtils.getFormattedDateForSubmit(this.completedAt[0]) : undefined,
                    completedAtLte: this.completedAt ? dateTimeUtils.getFormattedDateForSubmit(this.completedAt[1]) : undefined
                }
                this.$store.dispatch('setCurrentArrayFilters', filters)
            },
            clearUser() {
                this.usersSelected = []
            },
            clearScheduledAt() {
                this.scheduledAt = null
            },
            clearCompletedAt() {
                this.completedAt = null
            }
        }
    }

</script>

<style scoped>

.filters-wrapper {
    background-color: white;
    margin-bottom: 20px;
    padding: 0.5rem 0.5rem 1rem;
    border-radius: 4px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.filters-header {
    font-size: 20px;
    font-weight: 900;
}

.filters-container {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}

.form-field {
    padding: 0;
    margin: 0;
}

.filter {
    display: flex;
    flex-direction: column;
}

@media (max-width: 992px) {
    .filters-wrapper {
        align-items: center;
    }

    .filters-container {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        width: 100%;
    }

    .filters-container .filter {
        width: 100%;
    }

    .filter .mx-datepicker {
        width: 100%;
    }
}
</style>
